import { Button, message, Popconfirm, Table } from "antd";
import React from "react";

import type { ColumnsType } from "antd/es/table";

type ResultadoProps = {
  _id: string;
  idArmador: string;
  idAgente?: string;
  name: string;
  email: string;
  phone: string;
  tradelane: string;
};

type Props = {
  response: ResultadoProps[];
  onDelete?: (id: string) => void; // handler para apagar
};

const phoneFormat = (phone: string): string => {
  if (!phone) return "-";

  // Remove tudo que não é número
  const cleaned = phone.replace(/\D/g, "");

  // Exemplo de formatação: +55 (31) 99999-9999
  if (cleaned.length === 13) {
    return `+${cleaned.slice(0, 2)} (${cleaned.slice(2, 4)}) ${cleaned.slice(
      4,
      9
    )}-${cleaned.slice(9)}`;
  }

  // Exemplo de formatação: (31) 99999-9999
  if (cleaned.length === 11) {
    return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 7)}-${cleaned.slice(7)}`;
  }

  // Exemplo de formatação: (31) 9999-9999
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 6)}-${cleaned.slice(6)}`;
  }

  // Se não bater nenhum formato, retorna o número original
  return phone;
};


const returnArmador = (idArmador: string): string => {
  const armadores: Record<string, string> = {
    "1": "MAERSK",
    "2": "CMA-CGM",
    "3": "MSC",
    "4": "EXALOG",
    "5": "COSCO",
    "6": "HAPAG",
    "7": "ONE",
    "8": "HMM",
  };
  return armadores[idArmador] || "Desconhecido";
};

const returnAgente = (idAgente?: string): string => {
  const agentes: Record<string, string> = {
    "1": "MAERSK",
    "2": "CMA-CGM",
    "3": "MSC",
    "4": "EXALOG",
    "5": "COSCO",
    "6": "HAPAG",
    "7": "ONE",
    "8": "HMM",
    "555": "Freight Forwarder/NVOCC",
  };
  return idAgente ? agentes[idAgente] || "Desconhecido" : "-";
};

const mappingTradelane = (tradelane: string): string => {
  const mapping: Record<string, string> = {
    global: "Global",
    TPEastbound: "Trans-Pacific (Eastbound)",
    TPWestbound: "Trans-Pacific (Westbound)",
    AEWestbound: "Asia-Europe (Westbound)",
    EAEastbound: "Europe-Asia (Eastbound)",
    Asia: "Asia-Asia",
    TAEurope: "Trans-Atlantic (Europe)",
    TAUS: "Trans-Atlantic (US)",
    FALA: "From Asia to Latin America",
    FLAA: "From Latin America to Asia",
    FELA: "From Europe to Latin America",
    FLAE: "From Latin America to Europe",
    FNALA: "From North America to Latin America",
    FLANA: "From Latin America to North America",
    LA: "Latin America – Latin America",
  };

  return tradelane
    .split(",")
    .map((key) => mapping[key.trim()] || key)
    .join(", ");
};

const TabelaResultadosFornecedores: React.FC<Props> = ({ response, onDelete }) => {
  const email = localStorage.getItem("user_email");

  const columns: ColumnsType<ResultadoProps> = [
    {
      title: "#",
      dataIndex: "_id",
      key: "_id",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Carrier or Supplier",
      dataIndex: "idArmador",
      key: "idArmador",
      render: (idArmador: string) => returnArmador(idArmador),
    },

    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },

    {
      title: "E-mail",
      dataIndex: "email",
      key: "email",
    },

    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
      render: (phone: string) => phoneFormat(phone) || "-",
    },
    {
      title: "Department",
      dataIndex: "tradelane",
      key: "tradelane",
      render: (tradelane: string) => mappingTradelane(tradelane),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Popconfirm
          title="Confirmar exclusão?"
          onConfirm={() => {
            if (onDelete) {
              onDelete(record._id);
              message.success("Fornecedor apagado com sucesso.");
            }
          }}
          okText="Sim"
          cancelText="Não"
        >
          <Button danger size="small">
            Delete
          </Button>
        </Popconfirm>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={response}
      rowKey="_id"
      pagination={false}
    />
  );
};

export default TabelaResultadosFornecedores;
